import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class DpsDeletedVmService {

    constructor(public http: HttpClient) {
    }

    getDpsDeletedVmList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/deletedVMs')
    }

    getDpsVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/deleted-vms/deleted-vms.service.ts